import JwtDecode from 'jwt-decode'

export default class User {
  constructor ({ user_id, email, first_name, last_name, wallet_id, public_key, group_id, did }) {
    this.id = user_id
    this.email = email
    this.first_name = first_name || ''
    this.last_name = last_name || ''
    this.name = this.first_name + ' ' + this.last_name
  }

  static from (token) {
    try {
      const obj = JwtDecode(token)
      return new User(obj)
    } catch (_) {
      return null
    }
  }
}
